"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/heroBanner/index.ts
var heroBanner_exports = {};
__export(heroBanner_exports, {
  default: () => HeroBanner_default
});
module.exports = __toCommonJS(heroBanner_exports);
var import_index6 = require("./index.css");

// src/heroBanner/HeroBanner.tsx
var import_classnames8 = __toESM(require("classnames"));

// src/alert/index.ts
var import_index3 = require("./index.css");

// src/alert/Alert.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react = require("react");

// src/closeButton/index.ts
var import_index = require("./index.css");

// src/closeButton/CloseButton.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames2.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes3,
    children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/link/index.ts
var import_index2 = require("./index.css");

// src/link/Link.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/common/constants/index.ts
var externalLinkIconProps = {
  iconName: "up-right-from-square",
  iconStyle: "solid"
};

// src/link/link.module.scss
var link_module_default = {
  "heading-xxl": "link-module__heading-xxl___NWhiO",
  "wrapper": "link-module__wrapper___wxglA",
  "heading-xl": "link-module__heading-xl___reHWW",
  "heading-lg": "link-module__heading-lg___vrkyU",
  "heading-md": "link-module__heading-md___DgXip",
  "heading-sm": "link-module__heading-sm___p4wYS",
  "heading-xs": "link-module__heading-xs___4dzMP",
  "body-one": "link-module__body-one___9dMa8",
  "body-two": "link-module__body-two___A55Jq",
  "body-three": "link-module__body-three___U22yO",
  "body-four": "link-module__body-four___jLkaW",
  "overline-one": "link-module__overline-one___ujSBW",
  "overline-two": "link-module__overline-two___8OvVA",
  "overline-three": "link-module__overline-three___800o1",
  "strong": "link-module__strong___GfpHM",
  "em": "link-module__em___ihSMB",
  "figcaption": "link-module__figcaption___hOiiQ",
  "no-margin": "link-module__no-margin___DOAhW",
  "link": "link-module__link___nBh09",
  "link-primary": "link-module__link-primary___Cgm-i",
  "link-secondary": "link-module__link-secondary___xHFLi",
  "link-l": "link-module__link-l___3mskp",
  "link-m": "link-module__link-m___aQawz",
  "link-s": "link-module__link-s___zlJ-K",
  "link-xs": "link-module__link-xs___Pg8mp"
};

// src/link/Link.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Link = ({
  children,
  text,
  id,
  className,
  external,
  openInNewTab,
  href = "#",
  disabled,
  onClick,
  size = "m",
  type = "primary",
  role,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
  "a",
  {
    className: (0, import_classnames3.default)(
      link_module_default.link,
      link_module_default[`link-${type}`],
      link_module_default[`link-${size}`],
      className
    ),
    href: !disabled ? href : void 0,
    id,
    onClick: !disabled ? onClick : void 0,
    rel: openInNewTab || external ? "noopener noreferrer" : void 0,
    target: (openInNewTab || void 0) && "_blank",
    role,
    ...disabled ? { "aria-disabled": true } : {},
    ...HTMLAttributes3,
    children: [
      text || children,
      external && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...externalLinkIconProps })
    ]
  }
);
var Link_default = Link;

// src/alert/alert.module.scss
var alert_module_default = {
  "heading-xxl": "alert-module__heading-xxl___KFz-t",
  "wrapper": "alert-module__wrapper___hcmXt",
  "heading-xl": "alert-module__heading-xl___Sah5U",
  "heading-lg": "alert-module__heading-lg___C3tUE",
  "heading-md": "alert-module__heading-md___qxqzq",
  "heading-sm": "alert-module__heading-sm___M5Vi-",
  "heading-xs": "alert-module__heading-xs___jflZr",
  "body-one": "alert-module__body-one___nK1GQ",
  "body-two": "alert-module__body-two___CsJVf",
  "body-three": "alert-module__body-three___u265L",
  "body-four": "alert-module__body-four___ZRtqs",
  "overline-one": "alert-module__overline-one___07VjC",
  "overline-two": "alert-module__overline-two___VjFIk",
  "overline-three": "alert-module__overline-three___86CXQ",
  "strong": "alert-module__strong___nQfXJ",
  "em": "alert-module__em___U9Y48",
  "figcaption": "alert-module__figcaption___GOcmX",
  "no-margin": "alert-module__no-margin___PgAQj",
  "alert": "alert-module__alert___tzTnQ",
  "alertContentContainer": "alert-module__alertContentContainer___OuNdR",
  "alert-primary": "alert-module__alert-primary___4vRsD",
  "alert-success": "alert-module__alert-success___O5vlm",
  "alert-danger": "alert-module__alert-danger___hRxuR",
  "alert-warning": "alert-module__alert-warning___UDnBT",
  "alert-info": "alert-module__alert-info___5yPvt",
  "alert-gray": "alert-module__alert-gray___OSVhy",
  "alert-aqua": "alert-module__alert-aqua___-sG43",
  "alert-l": "alert-module__alert-l___Pp288",
  "alert-m": "alert-module__alert-m___ibdWz",
  "alert-s": "alert-module__alert-s___iKkxQ",
  "alert-xs": "alert-module__alert-xs___N52gK"
};

// src/alert/Alert.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var getDefaultAlertIconFromType = (type) => {
  const iconMap = {
    success: { iconName: "check-circle" },
    danger: { iconName: "circle-xmark" },
    warning: { iconName: "exclamation-circle" },
    info: { iconName: "circle-info" }
  };
  return iconMap[type];
};
var Alert = (0, import_react.forwardRef)(
  ({
    text,
    showIcon = true,
    icon,
    link,
    className,
    onClose,
    closeLabel = "Close alert",
    isImmediateImportance = true,
    type = "primary",
    size = "m",
    ...HTMLAttributes3
  }, ref) => {
    const iconToRender = (0, import_react.useMemo)(
      () => icon || getDefaultAlertIconFromType(type),
      [icon, type]
    );
    const closeButtonSize = size === "l" ? "l" : "m";
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
      "div",
      {
        ref,
        className: (0, import_classnames4.default)(
          alert_module_default.alert,
          alert_module_default[`alert-${type}`],
          alert_module_default[`alert-${size}`],
          className
        ),
        role: isImmediateImportance ? "alert" : "status",
        ...HTMLAttributes3,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: alert_module_default.alertContentContainer, children: [
            showIcon && iconToRender && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FontAwesomeV6Icon_default, { ...iconToRender }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: alert_module_default.alertText, children: [
              text,
              link && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_jsx_runtime4.Fragment, { children: [
                "\xA0\xA0",
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(Link_default, { ...link, size })
              ] })
            ] })
          ] }),
          onClose && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            CloseButton_default,
            {
              "aria-label": closeLabel,
              onClick: onClose,
              size: closeButtonSize
            }
          )
        ]
      }
    );
  }
);
Alert.displayName = "Alert";
var Alert_default = Alert;

// src/button/index.ts
var import_index4 = require("./index.css");

// src/button/GenericButton.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/button/genericButton.module.scss
var genericButton_module_default = {
  "heading-xxl": "genericButton-module__heading-xxl___9NP3V",
  "wrapper": "genericButton-module__wrapper___GQQ0H",
  "heading-xl": "genericButton-module__heading-xl___9RYlD",
  "heading-lg": "genericButton-module__heading-lg___kLhyo",
  "heading-md": "genericButton-module__heading-md___H3D4u",
  "heading-sm": "genericButton-module__heading-sm___zTZqI",
  "heading-xs": "genericButton-module__heading-xs___Ff2UG",
  "body-one": "genericButton-module__body-one___ERWHM",
  "body-two": "genericButton-module__body-two___7YQr-",
  "body-three": "genericButton-module__body-three___fRZrg",
  "body-four": "genericButton-module__body-four___Jxg8b",
  "overline-one": "genericButton-module__overline-one___HYiC4",
  "overline-two": "genericButton-module__overline-two___Oc9vT",
  "overline-three": "genericButton-module__overline-three___H7U-H",
  "strong": "genericButton-module__strong___S1okA",
  "em": "genericButton-module__em___2-8kG",
  "figcaption": "genericButton-module__figcaption___uJG4X",
  "no-margin": "genericButton-module__no-margin___p--A2",
  "button": "genericButton-module__button___-ZvEw",
  "buttonPendingWithHiddenText": "genericButton-module__buttonPendingWithHiddenText___vdKNV",
  "button-withForcedHover": "genericButton-module__button-withForcedHover___wNW5p",
  "button-tertiary": "genericButton-module__button-tertiary___c12xm",
  "button-primary": "genericButton-module__button-primary___QVgSO",
  "button-purple": "genericButton-module__button-purple___pE0jD",
  "button-black": "genericButton-module__button-black___7TWIL",
  "button-white": "genericButton-module__button-white___o5W2c",
  "button-destructive": "genericButton-module__button-destructive___G3NGM",
  "button-secondary": "genericButton-module__button-secondary___nipwy",
  "button-gray": "genericButton-module__button-gray___bk2Qr",
  "button-l": "genericButton-module__button-l___-YVB5",
  "button-iconOnly": "genericButton-module__button-iconOnly___h5FDS",
  "button-m": "genericButton-module__button-m___n6yyw",
  "button-s": "genericButton-module__button-s___RHPNT",
  "button-xs": "genericButton-module__button-xs___5ARP6"
};

// src/button/GenericButton.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var GenericButton = (0, import_react2.forwardRef)(
  ({
    className,
    id,
    disabled = false,
    isPending = false,
    ariaLabel,
    size = "m",
    type = "primary",
    color = "purple",
    buttonTagTypeAttribute = "button",
    /** Text button specific props */
    iconLeft,
    iconRight,
    text,
    /** IconOnly button specific props*/
    isIconOnly = false,
    icon,
    /** <a> specific props */
    useAsLink = false,
    href,
    target,
    download,
    title,
    analyticsCallback,
    /** <button> specific props */
    onClick,
    value,
    name,
    forceHover = false,
    ...rest
  }, ref) => {
    const ButtonTag = useAsLink ? "a" : "button";
    const tagSpecificProps = ButtonTag === "a" ? {
      href: disabled ? void 0 : href,
      target,
      /** Copied from old button component. Only need it for the older browsers,
       *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
      // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
      // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
      // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
      // Therefore, we do so here.
      rel: target === "_blank" ? "noopener noreferrer" : void 0,
      download,
      title,
      onClick: analyticsCallback
    } : { type: buttonTagTypeAttribute, onClick, value, name };
    (0, import_react2.useMemo)(
      () => checkButtonPropsForErrors({
        type,
        icon,
        useAsLink,
        onClick,
        href,
        download,
        text,
        isIconOnly,
        color
      }),
      [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
    );
    const showIcon = icon && !isPending;
    const showIconLeft = iconLeft && !isPending;
    const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
    const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
    const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      ButtonTag,
      {
        ref,
        className: (0, import_classnames5.default)(
          genericButton_module_default.button,
          genericButton_module_default[`button-${type}`],
          genericButton_module_default[`button-${color}`],
          genericButton_module_default[`button-${size}`],
          forceHover && genericButton_module_default["button-withForcedHover"],
          isIconOnly && genericButton_module_default["button-iconOnly"],
          addPendingButtonWithHiddenTextClass && genericButton_module_default.buttonPendingWithHiddenText,
          className
        ),
        id,
        disabled,
        ...rest,
        "aria-disabled": disabled || rest["aria-disabled"],
        "aria-label": ariaLabel || rest["aria-label"],
        ...tagSpecificProps,
        children: [
          isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
          showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
          showIcon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...icon }),
          text && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: text }),
          showIconRight && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
          isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
        ]
      }
    );
  }
);
var GenericButton_default = (0, import_react2.memo)(GenericButton);

// src/button/LinkButton.tsx
var import_react3 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
var LinkButton = (props) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(GenericButton_default, { useAsLink: true, ...props });
var LinkButton_default = (0, import_react3.memo)(LinkButton);

// src/image/index.ts
var import_index5 = require("./index.css");

// src/image/Image.tsx
var import_classnames6 = __toESM(require("classnames"));

// src/image/image.module.scss
var image_module_default = {
  "figureContainer": "image-module__figureContainer___jYA2e",
  "image": "image-module__image___vystJ",
  "figure-hasBorder": "image-module__figure-hasBorder___fP8EU",
  "figure-hasBoxShadow": "image-module__figure-hasBoxShadow___bqnjE",
  "figure-hasRoundedCorners": "image-module__figure-hasRoundedCorners___aJWq0"
};

// src/image/Image.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var Image = ({
  src,
  altText = "",
  loading = "lazy",
  decoration = "none",
  hasRoundedCorners = true,
  style,
  className,
  onLoad,
  onError,
  ImageComponent = "img",
  ...ImageHTMLAttributes
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    "figure",
    {
      className: (0, import_classnames6.default)(
        image_module_default.figureContainer,
        {
          [image_module_default["figure-hasBorder"]]: decoration === "border",
          [image_module_default["figure-hasBoxShadow"]]: decoration === "shadow",
          [image_module_default["figure-hasRoundedCorners"]]: hasRoundedCorners
        },
        className
      ),
      style,
      children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
        ImageComponent,
        {
          className: (0, import_classnames6.default)(image_module_default.image),
          alt: altText,
          loading,
          src,
          onLoad,
          onError,
          ...ImageHTMLAttributes
        }
      )
    }
  );
};
var Image_default = Image;

// src/typography/Typography.tsx
var import_classnames7 = __toESM(require("classnames"));
var import_react4 = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "wrapper": "typography-module__wrapper___6sEjE",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw",
  "no-margin": "typography-module__no-margin___dyDRA"
};

// src/typography/Typography.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  noMargin = false,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames7.default)(
        typography_module_default[visualAppearance],
        {
          [typography_module_default["no-margin"]]: noMargin,
          [typography_module_default.wrapper]: semanticTag === "div"
        },
        className
      ),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react4.memo)(Typography);

// src/typography/TypographyElements.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var typographyElementsToGenerate = [
  {
    displayName: "Heading1",
    semanticTag: "h1",
    defaultVisualAppearance: "heading-xxl"
  },
  {
    displayName: "Heading2",
    semanticTag: "h2",
    defaultVisualAppearance: "heading-xl"
  },
  {
    displayName: "Heading3",
    semanticTag: "h3",
    defaultVisualAppearance: "heading-lg"
  },
  {
    displayName: "Heading4",
    semanticTag: "h4",
    defaultVisualAppearance: "heading-md"
  },
  {
    displayName: "Heading5",
    semanticTag: "h5",
    defaultVisualAppearance: "heading-sm"
  },
  {
    displayName: "Heading6",
    semanticTag: "h6",
    defaultVisualAppearance: "heading-xs"
  },
  {
    displayName: "BodyOneText",
    semanticTag: "p",
    defaultVisualAppearance: "body-one"
  },
  {
    displayName: "BodyTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "body-two"
  },
  {
    displayName: "BodyThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "body-three"
  },
  {
    displayName: "BodyFourText",
    semanticTag: "p",
    defaultVisualAppearance: "body-four"
  },
  {
    displayName: "OverlineOneText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-one"
  },
  {
    displayName: "OverlineTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-two"
  },
  {
    displayName: "OverlineThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-three"
  },
  { displayName: "EmText", semanticTag: "em", defaultVisualAppearance: "em" },
  {
    displayName: "StrongText",
    semanticTag: "strong",
    defaultVisualAppearance: "strong"
  },
  {
    displayName: "Figcaption",
    semanticTag: "figcaption",
    defaultVisualAppearance: "figcaption"
  }
];
var generateComponents = (componentsToGenerate) => componentsToGenerate.reduce((acc, componentTemplateData) => {
  const { displayName, semanticTag, defaultVisualAppearance } = componentTemplateData;
  const TypographyElement = (componentProps) => {
    const { visualAppearance, children, className, style, id, noMargin } = componentProps;
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      Typography_default,
      {
        semanticTag,
        visualAppearance: visualAppearance || defaultVisualAppearance,
        noMargin,
        className,
        style,
        id,
        children
      }
    );
  };
  TypographyElement.displayName = displayName;
  return { ...acc, [displayName]: TypographyElement };
}, {});
var {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  BodyOneText,
  BodyTwoText,
  BodyThreeText,
  BodyFourText,
  OverlineOneText,
  OverlineTwoText,
  OverlineThreeText,
  EmText,
  StrongText,
  Figcaption
} = generateComponents(typographyElementsToGenerate);

// src/heroBanner/heroBanner.module.scss
var heroBanner_module_default = {
  "heading-xxl": "heroBanner-module__heading-xxl___QvJZp",
  "wrapper": "heroBanner-module__wrapper___BAdQE",
  "heading-xl": "heroBanner-module__heading-xl___UnJB8",
  "heading-lg": "heroBanner-module__heading-lg___r9XOt",
  "heading-md": "heroBanner-module__heading-md___2aPtw",
  "heading-sm": "heroBanner-module__heading-sm___E-cp1",
  "heading-xs": "heroBanner-module__heading-xs___xxCft",
  "body-one": "heroBanner-module__body-one___lW5bs",
  "body-two": "heroBanner-module__body-two___QzLOm",
  "body-three": "heroBanner-module__body-three___wSLxi",
  "body-four": "heroBanner-module__body-four___GHDmZ",
  "overline-one": "heroBanner-module__overline-one___4Joh7",
  "overline-two": "heroBanner-module__overline-two___Af4Wy",
  "overline-three": "heroBanner-module__overline-three___qntoG",
  "strong": "heroBanner-module__strong___Kh6xL",
  "em": "heroBanner-module__em___fvqkR",
  "figcaption": "heroBanner-module__figcaption___sC5iM",
  "no-margin": "heroBanner-module__no-margin___jod3D",
  "heroBanner": "heroBanner-module__heroBanner___bFw2O",
  "heroBannerWrapper": "heroBanner-module__heroBannerWrapper___TgsRq",
  "heroBanner-withWideText": "heroBanner-module__heroBanner-withWideText___vqqEe",
  "heroBannerTextContainer": "heroBanner-module__heroBannerTextContainer___wnc-j",
  "heroBannerMediaContainer": "heroBanner-module__heroBannerMediaContainer___2fAFk",
  "heroBannerAnnouncementBanner": "heroBanner-module__heroBannerAnnouncementBanner___vQbF7",
  "heroBannerContainer": "heroBanner-module__heroBannerContainer___S9Snk",
  "heroBannerPartnerContainer": "heroBanner-module__heroBannerPartnerContainer___45AMe",
  "heroBannerMediaImage": "heroBanner-module__heroBannerMediaImage___MCSeZ",
  "hideImageOnSmallScreen": "heroBanner-module__hideImageOnSmallScreen___pZO6N"
};

// src/heroBanner/HeroBanner.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var HeroBanner = ({
  heading,
  subHeading,
  description,
  partner,
  imageProps,
  hideImageOnSmallScreen = false,
  VideoComponent,
  videoProps,
  buttonProps,
  announcementBannerProps,
  backgroundColor,
  backgroundImageUrl,
  withWideText = false,
  className,
  ...HTMLAttributes3
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
    "section",
    {
      "data-theme": HTMLAttributes3["data-theme"],
      className: (0, import_classnames8.default)(heroBanner_module_default.heroBanner, className),
      ...HTMLAttributes3,
      children: [
        announcementBannerProps && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
          Alert_default,
          {
            "data-theme": HTMLAttributes3["data-theme"] === "Dark" ? "Light" : "Dark",
            className: heroBanner_module_default.heroBannerAnnouncementBanner,
            text: announcementBannerProps.text,
            icon: announcementBannerProps.icon,
            link: announcementBannerProps.link,
            type: "gray"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
          "div",
          {
            className: (0, import_classnames8.default)(heroBanner_module_default.heroBannerWrapper, {
              [heroBanner_module_default["heroBanner-withWideText"]]: withWideText
            }),
            style: {
              ...(_a = HTMLAttributes3.style) != null ? _a : {},
              backgroundColor: backgroundColor ? backgroundColor : (_b = HTMLAttributes3.style) == null ? void 0 : _b.backgroundColor,
              backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : (_c = HTMLAttributes3.style) == null ? void 0 : _c.backgroundImage
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: (0, import_classnames8.default)(heroBanner_module_default.heroBannerContainer), children: [
              /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: heroBanner_module_default.heroBannerTextContainer, children: [
                /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Heading1, { children: heading }),
                  subHeading && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(BodyOneText, { children: subHeading }),
                  description && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(BodyTwoText, { children: description }),
                  partner && /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("span", { className: heroBanner_module_default.heroBannerPartnerContainer, children: [
                    partner.title,
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Image_default, { ...partner.logo, hasRoundedCorners: false })
                  ] })
                ] }),
                buttonProps && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(LinkButton_default, { color: "purple", type: "primary", ...buttonProps }) })
              ] }),
              (imageProps || videoProps) && /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: heroBanner_module_default.heroBannerMediaContainer, children: [
                imageProps && !videoProps && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                  Image_default,
                  {
                    ...imageProps,
                    className: (0, import_classnames8.default)(
                      imageProps.className,
                      heroBanner_module_default.heroBannerMediaImage,
                      hideImageOnSmallScreen && heroBanner_module_default.hideImageOnSmallScreen
                    )
                  }
                ),
                VideoComponent && videoProps && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(VideoComponent, { ...videoProps })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
var HeroBanner_default = HeroBanner;
//# sourceMappingURL=index.js.map